import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent } from "../lib/cookieConsent";

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getConsent());
  }, []);

  if (!visible) return null;

  const choose = (level) => {
    setConsent(level);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-[var(--rs-border)] shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-5 flex flex-col lg:flex-row items-start lg:items-center gap-4">
        <p className="text-sm text-[var(--rs-muted)] leading-relaxed flex-1">
          We use cookies to run this site. Strictly necessary cookies are always on; you choose whether we use anything beyond that.
          See our{" "}
          <Link to="/privacy-policy" className="text-[var(--rs-blue)] font-medium hover:underline">
            Privacy Policy
          </Link>{" "}
          for details.
        </p>
        <div className="flex flex-wrap gap-3 shrink-0">
          <button onClick={() => choose("all")} className="btn-primary rounded-lg px-5 py-2.5 text-sm font-semibold">
            Allow All
          </button>
          <button onClick={() => choose("necessary")} className="btn-outline rounded-lg px-5 py-2.5 text-sm font-semibold">
            Allow Necessary Only
          </button>
          <button
            onClick={() => choose("none")}
            className="rounded-lg px-5 py-2.5 text-sm font-semibold text-[var(--rs-muted)] hover:text-[var(--rs-ink)]"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
